import { render } from "./SaveBetting.vue?vue&type=template&id=4b1113af"
import script from "./SaveBetting.vue?vue&type=script&lang=js"
export * from "./SaveBetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__